import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import classNames from "classnames";
import { translateBackendErrorCode } from "@jti/fe-common";
import { getUser, LoyaltyApi } from "@jti/rest-api";
import { HeroContentAuthoringWrapper, replaceStringPlaceholder, useTranslations, } from "@jti/ui";
import { REPLACE_URL_PLACEHOLDER, replaceLoginWithRedirectionUrlPlaceholder, } from "../../helpers/functions/replaceLoginWithRedirectionUrlPlaceholder";
const convertLoggedCtas = (ctas) => {
    return ctas
        .filter(({ additionalBehavior }) => additionalBehavior !== "onlyForLoggedIn")
        .map((item) => {
        const additionalBehavior = item.additionalBehavior === "onlyAfterCollection" ? "onlyForLoggedIn" : item.additionalBehavior;
        return {
            ...item,
            additionalBehavior,
        };
    });
};
const convertCtaPlaceHolder = (ctas) => {
    return ctas.map((item) => {
        if (item.link === REPLACE_URL_PLACEHOLDER) {
            return { ...item, link: replaceLoginWithRedirectionUrlPlaceholder(item.link) };
        }
        return item;
    });
};
export const sanitizeAdditionalBehavior = (ctas) => {
    return ctas.flatMap((item) => {
        return item.additionalBehavior === "onlyAfterCollection"
            ? []
            : [{ ...item, additionalBehavior: item.additionalBehavior }];
    });
};
const createNewContent = (props, showAlreadyCollectedState, earnedPoints) => {
    const ctaCheckedForPlaceholder = convertCtaPlaceHolder(props.content.cta || []);
    const { titleLogged } = props.content;
    if (showAlreadyCollectedState) {
        return {
            ...props.content,
            titleLogged: props.content.titleCollected,
            textLogged: props.content.textCollected,
            cta: convertLoggedCtas(ctaCheckedForPlaceholder),
        };
    }
    if (typeof earnedPoints === "number") {
        return {
            ...props.content,
            titleLogged: replaceStringPlaceholder(typeof titleLogged === "string" ? titleLogged : "", [
                {
                    placeholder: "pointsEarned",
                    value: earnedPoints,
                },
            ], false),
        };
    }
    return {
        ...props.content,
        cta: sanitizeAdditionalBehavior(ctaCheckedForPlaceholder),
    };
};
const createNewProps = (props, showAlreadyCollectedState, earnedPoints) => {
    const newContent = createNewContent(props, showAlreadyCollectedState, earnedPoints);
    return {
        ...props,
        content: {
            ...props.content,
            ...newContent,
        },
        isViewportHeight: false,
        isContainerWidth: true,
    };
};
export const QrCodePointsCollection = ({ isInEditor, ...props }) => {
    const { __ } = useTranslations();
    const user = getUser();
    const [rewardId, setRewardId] = useState(undefined);
    const [earnedPoints, setEarnedPoints] = useState(undefined);
    const [showAlreadyCollectedState, setShowAlreadyCollectedState] = useState(!rewardId);
    const [isLoading, setIsLoading] = useState(false);
    const newProps = createNewProps(props, showAlreadyCollectedState, earnedPoints);
    const classes = classNames("loyalty__qrCodePointsCollection", {
        "hero-banner-v2--authoring": isInEditor,
    });
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const rewardId = params.get("rewardId");
        if (rewardId) {
            setRewardId(rewardId);
            setShowAlreadyCollectedState(false);
        }
    }, []);
    useEffect(() => {
        if (!isInEditor && user?.ciam_token && rewardId) {
            setIsLoading(true);
            LoyaltyApi.init()
                .scanQrAction(rewardId, user.ciam_token)
                .then((response) => {
                setEarnedPoints(response.earned_points);
            })
                .catch((response) => {
                if (response.statusCode !== 409) {
                    const preparedError = translateBackendErrorCode(response?.error_code, __("loyalty.qrCodePointsCollection.error"));
                    toast.error(preparedError);
                }
                setShowAlreadyCollectedState(true);
            })
                .finally(() => setIsLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rewardId]);
    return (_jsx("div", { className: classes, children: _jsx(HeroContentAuthoringWrapper, { data: newProps, isLoading: isLoading }) }));
};
//# sourceMappingURL=QrCodePointsCollection.js.map